// Default
import '../../custom/js/default';

//// JS
//import '../../custom/js/indexOptimized';
//import Validation from '../../custom/js/base/validation';

//// Base SCSS
//import '../../custom/scss/style.scss';

//$(() => {
//	const validation = new Validation();
//	validation.init();
//});